import React from "react";
import { Route, Routes } from "react-router-dom";
import { DownloadingProjects, PageAnalitysSizeProyect, LPHours, TableWeeks } from "../pages/inmersys";
import { OverTime } from "../pages/inmersys/anality";
import { AnalityRoot } from "./type_router";

export const AnalityRouter = () => {
    return (
        <Routes path="/">
            <Route path={AnalityRoot.sizeProyect} element={<PageAnalitysSizeProyect />} />
            <Route path={AnalityRoot.download} element={<DownloadingProjects />} />
            <Route path={AnalityRoot.redProjects} element={<OverTime />} />
            <Route path={AnalityRoot.tableWeeks} element={<TableWeeks />} />
            <Route path={AnalityRoot.lp} element={<LPHours />} />
        </Routes>
    );
};
